import { render } from "./App.vue?vue&type=template&id=d0352064"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d0352064&lang=css"
/* custom blocks */
import block0 from "./use-cases.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fxai-demonstrator%2Fxai-demonstrator%2Flanding-page%2Ffrontend%2Fsrc%2FApp.vue"
if (typeof block0 === 'function') block0(script)
import block1 from "./App.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/runner/work/xai-demonstrator/xai-demonstrator/landing-page/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__